import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LoadingService } from "../../core/loader/loading.service";

@Component({
  selector: "app-index",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.css"],
})
export class IndexComponent implements OnInit {
  loading$ = this.loader.loading$;

  constructor(public router: Router, public loader: LoadingService) {}

  ngOnInit(): void {}
}
